import { render, staticRenderFns } from "./HomeTechnologies.vue?vue&type=template&id=505e796e&scoped=true&"
import script from "./HomeTechnologies.vue?vue&type=script&lang=js&"
export * from "./HomeTechnologies.vue?vue&type=script&lang=js&"
import style0 from "./HomeTechnologies.vue?vue&type=style&index=0&id=505e796e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505e796e",
  null
  
)

export default component.exports